var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewAndonButtonStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 76,
    viewBox: "0 0 84 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1168_100706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6964 107.465C26.6407 105.523 21.0915 102.714 17.9028 100.235C17.0531 99.5588 15.3535 97.9826 15.3535 97.0883C15.3535 96.194 15.3949 91.8005 15.3949 89.6614L93.8524 83.5497V88.6422C93.8524 88.8078 93.7144 89.0306 93.6454 89.1213C92.5272 90.1542 88.9575 93.3107 83.6237 97.6736C78.2898 102.036 73.4501 104.036 71.697 104.491C58.3127 108.093 48.1198 107.975 44.6964 107.465Z",
    fill: "#532F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6964 107.465C26.6407 105.523 21.0915 102.714 17.9028 100.235C17.0531 99.5588 15.3535 97.9826 15.3535 97.0883C15.3535 96.194 15.3949 91.8005 15.3949 89.6614L93.8524 83.5497V88.6422C93.8524 88.8078 93.7144 89.0306 93.6454 89.1213C92.5272 90.1542 88.9575 93.3107 83.6237 97.6736C78.2898 102.036 73.4501 104.036 71.697 104.491C58.3127 108.093 48.1198 107.975 44.6964 107.465Z",
    fill: "#929AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8524 83.5497C93.8524 85.1782 93.8524 88.4766 93.8524 88.6422C93.8524 88.8078 93.7144 89.0306 93.6454 89.1213C92.5272 90.1542 88.9575 93.3107 83.6237 97.6736C78.2898 102.036 73.4501 104.036 71.697 104.491C58.3127 108.093 48.1198 107.975 44.6964 107.465C26.6407 105.523 21.0915 102.714 17.9028 100.235C17.0531 99.5588 15.3535 97.9826 15.3535 97.0883C15.3535 96.194 15.3949 91.8005 15.3949 89.6614L93.8524 83.5497ZM93.8524 83.5497C93.8524 83.3013 93.6702 82.614 92.9416 81.8522C92.2129 81.0904 90.9818 79.8235 90.4574 79.2853V68.8519C90.4988 68.3688 90.3995 66.9391 89.6708 65.0842C88.9421 63.2294 85.3097 52.2771 83.5846 47.0328C81.5962 40.988 76.5116 28.206 76.3129 15.156",
    stroke: "#4E2C6E",
    strokeWidth: 0.331219
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4697 75.9731C38.2914 72.8265 39.4645 68.0377 39.8233 66.0365C49.056 65.5896 68.7636 61.276 73.7318 47.5966L76.3976 14.6226C76.4046 14.5114 76.4131 14.4069 76.423 14.3091L76.3976 14.6226C76.112 19.1705 78.3286 34.9328 89.5475 64.613C89.9064 65.5101 90.6074 67.7016 90.5412 69.2915C90.475 70.8813 90.4032 76.7821 90.3756 79.5337C87.7534 81.6314 81.3002 86.7626 76.4644 90.5054C71.6286 94.2481 63.2156 96.1499 59.6136 96.6329C43.5495 98.7444 33.6129 95.7221 30.1766 94.5214C28.5333 93.9473 24.521 92.4844 22.1031 89.6359C19.6852 86.7874 23.1106 83.8672 25.1255 82.7631C27.4578 81.4934 32.4951 78.7305 33.9856 77.8362C35.4761 76.9419 36.2627 76.2215 36.4697 75.9731Z",
    fill: "#384250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4697 75.9731C38.2914 72.8265 39.4645 68.0377 39.8233 66.0365C49.056 65.5896 68.7636 61.276 73.7318 47.5966L76.3976 14.6226C76.4046 14.5114 76.4131 14.4069 76.423 14.3091L76.3976 14.6226C76.112 19.1705 78.3286 34.9328 89.5475 64.613C89.9064 65.5101 90.6074 67.7016 90.5412 69.2915C90.475 70.8813 90.4032 76.7821 90.3756 79.5337C87.7534 81.6314 81.3002 86.7626 76.4644 90.5054C71.6286 94.2481 63.2156 96.1499 59.6136 96.6329C43.5495 98.7444 33.6129 95.7221 30.1766 94.5214C28.5333 93.9473 24.521 92.4844 22.1031 89.6359C19.6852 86.7874 23.1106 83.8672 25.1255 82.7631C27.4578 81.4934 32.4951 78.7305 33.9856 77.8362C35.4761 76.9419 36.2627 76.2215 36.4697 75.9731Z",
    fill: "#838B96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2273 77.8362C34.8298 77.6706 35.0617 77.298 35.2273 77.1324C35.5585 76.8787 36.2541 76.3382 36.3865 76.2057C36.519 76.0732 36.7454 75.6813 36.842 75.5019C37.67 73.7216 39.4255 69.3495 39.8229 66.1035C40.4164 66.3211 42.2408 66.7945 44.7912 66.9474C44.4186 73.4476 41.272 78.6229 40.9822 79.2025C40.7504 79.6662 40.306 79.7546 40.1128 79.7408C38.6499 79.1749 35.6247 78.0019 35.2273 77.8362Z",
    fill: "#949CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4063 30.5548L13.1993 -117.376C13.1825 -129.344 18.7502 -138.263 24.4135 -143.915C27.3862 -146.882 30.3853 -148.949 32.617 -150.084C38.7997 -152.996 54.1071 -157.721 63.9586 -150.539C74.8059 -142.631 77.2439 -132.612 77.2073 -126.195C76.9313 -77.7815 76.6028 24.1788 76.5035 33.453C76.4041 42.7271 73.2879 49.8759 71.7422 52.2911C67.4087 59.4537 54.2042 71.9903 36.0534 64.836C26.1143 60.9184 20.2654 53.5447 17.0097 46.2877C14.3197 40.292 13.4 34.376 13.4063 30.5548Z",
    fill: "#54CF8D",
    stroke: "#039855",
    strokeWidth: 0.854516
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8907 -127.892C22.0183 -145.579 35.6949 -150.305 41.7672 -150.456C61.5741 -151.251 65.8358 -133.619 65.4908 -124.704C65.27 -73.9862 64.8366 28.965 64.8697 35.0263C64.9029 41.0877 62.0406 48.1233 60.6053 50.8835C55.1733 61.5487 43.4095 62.3657 38.2066 61.4411C18.9628 57.5327 14.2622 39.3322 14.3175 30.7205C14.1794 -15.9124 13.8868 -110.445 13.8206 -115.513C13.7544 -120.58 15.1731 -125.877 15.8907 -127.892Z",
    fill: "#929AA4",
    stroke: "#384250",
    strokeWidth: 0.496829
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8605 -118.134C24.9546 -139.208 38.3396 -139.138 39.9182 -139.167C48.9025 -139.332 54.9472 -132.749 54.4389 -115.015C54.303 -68.8837 54.0568 24.7583 54.0568 30.2715L54.0565 30.4646C54.05 34.2751 54.0476 35.669 53.4923 37.7458C51.7593 43.5835 43.8597 51.3258 34.4531 48.3448C25.0465 45.3638 22.7224 34.7924 22.7362 29.8793C22.6513 -12.5368 22.6956 -102.046 22.6548 -106.655C22.6141 -111.265 22.6547 -116.064 22.8605 -118.134Z",
    fill: "#57317A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8605 -118.134C24.9546 -139.208 38.3396 -139.138 39.9182 -139.167C48.9025 -139.332 54.9472 -132.749 54.4389 -115.015C54.303 -68.8837 54.0568 24.7583 54.0568 30.2715L54.0565 30.4646C54.05 34.2751 54.0476 35.669 53.4923 37.7458C51.7593 43.5835 43.8597 51.3258 34.4531 48.3448C25.0465 45.3638 22.7224 34.7924 22.7362 29.8793C22.6513 -12.5368 22.6956 -102.046 22.6548 -106.655C22.6141 -111.265 22.6547 -116.064 22.8605 -118.134Z",
    fill: "#838B96"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1168_100706)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.3674,
    cy: 32.4286,
    rx: 8.027,
    ry: 9.56407,
    transform: "rotate(-9.2855 36.3674 32.4286)",
    fill: "url(#paint0_linear_1168_100706)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.2075 31.1468C45.0546 36.3285 42.2143 41.0798 37.8972 41.7856C33.5801 42.4915 29.3745 38.8922 28.5273 33.7104C27.6801 28.5287 30.5204 23.7774 34.8375 23.0716C39.1547 22.3657 43.3603 25.965 44.2075 31.1468Z",
    stroke: "#384250",
    strokeWidth: 0.16561
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8666 31.6096C42.4988 35.4763 40.3789 39.0149 37.1659 39.5402C33.953 40.0655 30.8165 37.3863 30.1843 33.5196C29.5521 29.6529 31.672 26.1143 34.885 25.589C38.0979 25.0637 41.2344 27.7429 41.8666 31.6096Z",
    fill: "url(#paint1_radial_1168_100706)",
    stroke: "#384250",
    strokeWidth: 0.168148
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8294,
    cy: 32.542,
    rx: 4.45843,
    ry: 5.31217,
    transform: "rotate(-9.2855 35.8294 32.542)",
    fill: "url(#paint2_radial_1168_100706)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6703 31.9007C40.094 34.4926 38.6734 36.8704 36.5125 37.2237C34.3515 37.577 32.2476 35.7754 31.8238 33.1836C31.4001 30.5918 32.8207 28.214 34.9816 27.8606C37.1426 27.5073 39.2465 29.3089 39.6703 31.9007Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0745242
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2638 31.9737C39.6452 34.3063 38.3666 36.4464 36.4218 36.7644C34.4769 37.0823 32.5834 35.4609 32.202 33.1283C31.8206 30.7956 33.0992 28.6556 35.044 28.3376C36.9889 28.0196 38.8824 29.641 39.2638 31.9737Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0670719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9263 32.0884C39.2696 34.1878 38.1189 36.1138 36.3685 36.4C34.6181 36.6862 32.9139 35.2269 32.5707 33.1275C32.2274 31.0281 33.3781 29.1021 35.1285 28.8159C36.8789 28.5297 38.5831 29.989 38.9263 32.0884Z",
    stroke: "#1F2A37",
    strokeWidth: 0.0603648
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9966 89.9142C92.4013 62.7956 87.1018 56.9579 78.7385 39.4861C78.7385 42.3014 78.0209 46.2957 76.6082 50.6647C80.5138 56.5715 85.7332 72.815 75.3661 90.5353C75.3523 90.6043 75.3826 90.7423 75.6145 90.7423C75.8463 90.7423 81.0658 90.6043 83.6466 90.5353C83.6995 90.5353 83.8436 90.4111 83.9966 89.9142Z",
    fill: "#949CA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1168_100706",
    x: 27.6325,
    y: 22.569,
    width: 16.807,
    height: 19.3879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.662438,
    dy: -0.331219
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.414024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1168_100706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_100706",
    x1: 44.1714,
    y1: 31.4961,
    x2: 28.4921,
    y2: 32.4566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1168_100706",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7993 32.6001) rotate(79.5715) scale(6.96715 6.09557)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.769445,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789313,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822597,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871256,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911145,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939524,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967989,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1168_100706",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8294 32.542) rotate(90) scale(5.31217 4.45843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1168_100706"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.508789 4H62.7461C74.2037 4 83.4918 13.2882 83.4918 24.7458V51.2542C83.4918 62.7118 74.2036 72 62.7461 72H21.2545C9.79696 72 0.508789 62.7118 0.508789 51.2542V4Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAndonButtonStatus);
export default __webpack_public_path__ + "static/media/NewAndonButtonStatus.26d7fb8429eeb2d43c39002cbf4d72be.svg";
export { ForwardRef as ReactComponent };